import { FaHeart, FaMapMarkerAlt } from "react-icons/fa";
import { HiPhone } from "react-icons/hi";
import { RiQuestionnaireFill } from "react-icons/ri";
import { BiCalendar } from "react-icons/bi";
import { Button, Flex, Text, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import colors from "core/resources/theme/colors";

interface InformationsFooterProps {
  isLargerThan800: boolean;
}

export default function InformationsFooter({
  isLargerThan800,
}: InformationsFooterProps) {
  const navigate = useNavigate();
  return (
    <Flex
      justify="center"
      align={isLargerThan800 ? "flex-start" : "center"}
      textAlign={isLargerThan800 ? "start" : "center"}
      gap={10}
      bg={colors.newOrange}
      h="max-content"
      py="40px"
      px={"40px"}
      flexDir={isLargerThan800 ? "row" : "column"}
    >
      <Flex flexDir="column" align={isLargerThan800 ? "flex-start" : "center"}>
        <Flex gap={2} align="center" mb={4}>
          <Heading
            variant="superCellMagic"
            fontSize="18px"
            fontWeight="medium"
            color="white"
          >
            Sobre nós
          </Heading>
          <FaHeart color="white" />
        </Flex>
        <Flex
          flexDir="column"
          gap={2}
          cursor="pointer"
          onClick={() => navigate("/parque-aquatico")}
        >
          <Text fontSize="18px" color="white">
            Parque aquático
          </Text>
        </Flex>
      </Flex>

      <Flex flexDir="column" align={isLargerThan800 ? "flex-start" : "center"}>
        <Flex gap={2} align="center" mb={4}>
          <Heading
            variant="superCellMagic"
            fontSize="18px"
            fontWeight="medium"
            color="white"
          >
            Ajuda
          </Heading>
          <RiQuestionnaireFill color="white" />
        </Flex>
        <Flex cursor="pointer" onClick={() => navigate("/duvidas")}>
          <Text fontSize="18px" color="white">
            Dúvidas frequentes
          </Text>
        </Flex>
      </Flex>

      <Flex flexDir="column" align={isLargerThan800 ? "flex-start" : "center"}>
        <Flex gap={2} align="center" mb={4}>
          <Heading
            variant="superCellMagic"
            fontSize="18px"
            fontWeight="medium"
            color="white"
          >
            Venha se divertir
          </Heading>
          <BiCalendar color="white" />
        </Flex>
        <Flex flexDir="column" gap={2} fontSize="14px" maxW="300px">
          <Text color="white">
            Sábado, domingo : 9h às 17h *Consultar calendário de abertura.
          </Text>
        </Flex>
      </Flex>

      <Flex flexDir="column" align={isLargerThan800 ? "flex-start" : "center"}>
        <Flex gap={2} align="center" mb={4}>
          <Heading
            variant="superCellMagic"
            fontSize="18px"
            fontWeight="medium"
            color="white"
          >
            Como chegar
          </Heading>
          <FaMapMarkerAlt color="white" />
        </Flex>
        <Flex
          flexDir="column"
          gap={4}
          fontSize="14px"
          maxW="300px"
          align={"center"}
        >
          <Text color="white">
            Rodovia Vicente Bezerra Neto, km 05 (Estrada do Manso) Cuiabá, Mato
            Grosso - Brasil. 78005-000
          </Text>
          <Button
            w="150px"
            bg="none"
            border="solid 1px white"
            _hover={{ background: "none" }}
            onClick={() => navigate("/como-chegar")}
            color="white"
          >
            Ver no mapa
          </Button>
        </Flex>
      </Flex>

      <Flex flexDir="column" align={isLargerThan800 ? "flex-start" : "center"}>
        <Flex gap={2} align="center" mb={4}>
          <Heading
            variant="superCellMagic"
            fontSize="18px"
            fontWeight="medium"
            color="white"
          >
            Atendimento
          </Heading>
          <HiPhone color="white" />
        </Flex>
        <Flex flexDir="column" gap={2} fontSize="14px">
          <a
            href={`https://wa.me/5565999999102`}
            target="_blank"
            rel="noreferrer"
          >
            <Text color="white">(65) 9 9999-9102</Text>
          </a>
          <Text
            color="white"
            cursor="pointer"
            onClick={() => navigate("/registro-pcd")}
          >
            Solicitação PCD
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
